import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import {
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { toggleNAccessoryFoldSlide, toggleNWinDoor } from "Constants/Constants";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { foldSlideImageName } from "Constants/FoldSlideImageName";
import { ReactSVG } from "react-svg";
import GetPopModel from "Helpers/GetPopModel";
import GetIdPop from "Helpers/GetIdPop";
import { onSelectTools } from "Stores/actions";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useTranslation } from "react-i18next";

function FoldSlide({ openDialog, handleDialog }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const { selectedTool, popList, unitInfo } = useSelector((state) => ({
    selectedTool: state.design.selectedTool,
    popList: state.design.popList,
    unitInfo: state.design.unitInfo,
  }));
  const [formValid, setFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageName, setImageName] = useState(null);
  const [leafInfo, setLeafInfo] = useState([]);
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    winDoor: {
      type: "toggle",
      arrayItems: toggleNWinDoor,
      value: toggleNWinDoor[0],
      validation: {
        required: true,
      },
    },
    accessoryMode: {
      type: "toggle",
      arrayItems: toggleNAccessoryFoldSlide,
      value: toggleNAccessoryFoldSlide[2],
      validation: {
        required: true,
      },
    },
    leafCount: {
      type: "number",
      value: "2",
      validation: {
        required: true,
        min: 2,
        max: 7,
      },
    },
  });
  const [images, setImages] = useState([]);

  const onChangeToggle = (name, key, value) => {
    setImageName(null);
    setControls({ [name]: { value: value } });
  };

  const setValue = (name, value, validation) => {
    setImageName(null);
    setControls({ [name]: { value: value } });
    setFormValid(validation);
  };

  const onFinish = () => {
    const leafData = {
      tedad_lengeh: +controls.leafCount.value,
      id_adaptor: unitInfo.Id_averhang,
      width_adaptor: 30,
      stripeBrand: unitInfo.Id_brand_fitting,
      lengeh: leafInfo,
    };
    const tool = {
      title: "accordion",
      type: "foldSlide",
      auth: [0, 1, 2],
      data: leafData,
    };
    dispatch(onSelectTools(tool));
    handleDialog();
    showNotify({
      text: t("clickToSelectDesiredLocation"),
      customClass: "warning",
    });
  };

  const onEnter = () => {};

  const foldSlideClick = (name) => {
    setImageName(name);
  };

  useEffect(() => {
    if (+controls.leafCount.value >= 2 && +controls.leafCount.value <= 7) {
      const icons = [];
      for (let img in foldSlideImageName) {
        if (
          foldSlideImageName[img].key.startsWith(
            `AK${controls.accessoryMode.value.value}_${controls.leafCount.value}`
          )
        ) {
          const name = foldSlideImageName[img].key;
          icons.push(
            <div key={"itemkey-" + name}>
              <IconButton
                onClick={() => foldSlideClick(name)}
                className={`w-100 ${
                  imageName === name && "selected"
                } designButton`}
              >
                <ReactSVG
                  src={foldSlideImageName[img].icon}
                  alt=""
                  width="auto"
                  height={25}
                />
              </IconButton>
            </div>
          );
        }
      }
      setImages(icons);
    } else {
      setImageName(null);
      setImages([]);
    }
  }, [controls.accessoryMode.value, controls.leafCount, imageName]);

  useEffect(() => {
    if (imageName) {
      const popModels = imageName.split("_")[2].split("");
      const idSash =
        controls.winDoor.value.value === 1
          ? unitInfo.Id_sash
          : unitInfo.Id_sash_door;
      const sizeSash =
        controls.winDoor.value.value === 1
          ? unitInfo.Size_sash_win
          : unitInfo.Size_sash_door;
      const leafArray = popModels.map((item, index) => {
        const typeName = item <= 4 ? "Akardeoni" : "TakHalateh";
        return {
          place: ++index,
          popModel: GetPopModel(controls.winDoor.value.value, item),
          id_pop: GetIdPop(
            popList,
            unitInfo["Type_struct"],
            controls.winDoor.value.value,
            typeName
          ),
          id_sash: idSash,
          size_sash: sizeSash,
        };
      });
      setLeafInfo(leafArray);
    }
  }, [
    controls.winDoor.value,
    imageName,
    popList,
    selectedTool.name,
    selectedTool.type,
    unitInfo,
  ]);

  return (
    <>
      <>
        <Dialog
          dir={direction}
          open={openDialog}
          onClose={handleDialog}
          onEnter={onEnter}
          fullWidth
          maxWidth="sm"
        >
          <div className="dialogHeader">
            <p>
              <Translator id={"accordion_Settings"} />
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index}>
                    {controls[key].type === "toggle" && (
                      <MuiRadioGroup
                        name={key}
                        value={controls[key].value}
                        items={controls[key].arrayItems}
                        onChange={onChangeToggle}
                        translate={true}
                        className="horizontalRadio"
                        disabled={loading}
                      />
                    )}
                    {controls[key].type === "number" && (
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        checkValid={!formValid}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        value={controls[key].value}
                        // inputComponent={FoldSlideCountMask}
                        disabled={loading}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
            <Grid container spacing={1} className="mt-3 mb-2 d-flex">
              {images.length === 0 ? (
                <span className="w-100 text-center">{t("noData2Display")}</span>
              ) : (
                images.map((item) => {
                  return (
                    <Grid item className="flex-grow-1 mb-2">
                      {item}
                    </Grid>
                  );
                })
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              onClick={onFinish}
              disabled={imageName === null || images.length === 0}
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </Dialog>
      </>
    </>
  );
}

export default FoldSlide;
